import { useState } from 'react'

const ImageWithFallback = ({ src, alt }) => {
  const [isLoaded, setIsLoaded] = useState(!!src)

  const handleError = () => {
    setIsLoaded(false)
  }

  if (!isLoaded) return null

  return (
    <div className="cmp-teaser__image">
      <div data-cmp-is="image" className="cmp-image">
        <img
          src={src}
          alt={alt}
          onError={handleError}
          data-customlink="nl:body content"
        />
      </div>
    </div>
  )
}

export default ImageWithFallback
